<button type="button" [disabled]="disabled || loading" (click)="handleClick()" class="btn" [ngClass]="{
    'btn-primary': variant === 'primary',
    'btn-secondary': variant === 'secondary',
    'btn-danger': variant === 'danger',
    'btn-ghost': variant === 'ghost',
    'btn-small': size === 'small',
    'btn-medium': size === 'medium',
    'btn-large': size === 'large',
    'btn-loading': loading,
    'btn-full-width': fullWidth,
    'btn-icon-only': icon && !text
  }">

  @if (loading) {
    <fa-icon icon="spinner" animation="spin" class="btn-icon"></fa-icon>
  }

  @if (!loading) {
    @if (icon && iconPosition === 'left') {
      <fa-icon [icon]="icon" class="btn-icon btn-icon-left">
      </fa-icon>
    }
    @if (text) {
      <span class="btn-text">{{ text }}</span>
    }
    @if (!text) {
      <ng-content></ng-content>
    }
    @if (icon && iconPosition === 'right') {
      <fa-icon [icon]="icon" class="btn-icon btn-icon-right">
      </fa-icon>
    }
  }
</button>